import { createTheme, createVariant, globalTheme } from '@clds/component-theme';
const { palette } = globalTheme;
export const toggleTheme = createTheme({
    pill: {
        size: '0.625rem',
        position: {
            top: '0.125rem',
            left: {
                inactive: '0.125rem',
                active: globalTheme.spacing.sm,
            },
        },
        color: {
            base: palette.surfaceAlt,
            focus: palette.surfaceAlt,
            disabled: palette.secondaryAlt,
        },
    },
    toggle: {
        width: '1.5rem',
        height: '0.875rem',
        radius: globalTheme.radius.xl,
        color: {
            disabled: palette.secondary,
        },
    },
    focus: {
        shadow: {
            size: '3px',
        },
        color: palette.primary,
    },
    // variants
    none: {
        pill: {
            color: {
                active: palette.primary,
            },
        },
        toggle: {
            color: {
                base: palette.secondaryAlt,
                active: palette.primary,
            },
        },
    },
    success: {
        pill: {
            color: {
                active: palette.success,
            },
        },
        toggle: {
            color: {
                base: palette.success,
                active: palette.success,
            },
        },
    },
    error: {
        pill: {
            color: {
                active: palette.error,
            },
        },
        toggle: {
            color: {
                base: palette.error,
                active: palette.error,
            },
        },
    },
    warning: {
        pill: {
            color: {
                active: palette.warning,
            },
        },
        toggle: {
            color: {
                base: palette.warning,
                active: palette.warning,
            },
        },
    },
});
export const typeVariant = createVariant((props) => toggleTheme[props.validationState]);
//# sourceMappingURL=theme.js.map